<template>
  <div style="display: flex; align-items: flex-start">
    <sidebar style="margin-right: 20px; max-width: 200px" />
    <el-card style="width: 100%">
      <div
        slot="header"
        class="clearfix"
      >
        <span>Jogkörök</span>
        <el-button
          style="float: right; margin-top: -5px;"
          type="success"
          size="small"
          @click="$router.replace('/roles/add')"
          icon="el-icon-plus"
          v-can="'role.create'"
        >
          Új jogkör
        </el-button>
      </div>
      <list />
      <template v-if="$route.meta.showViewRoleDialog">
        <view-dialog
          :roleId="$route.params.id"
        />
      </template>
      <template v-if="$route.meta.showAddRoleDialog">
        <role-dialog
          type="add"
        />
      </template>
      <template v-if="$route.meta.showUpdateRoleDialog">
        <role-dialog
          :roleId="$route.params.id"
          type="update"
        />
      </template>
    </el-card>
  </div>
</template>

<script>
  import List from '../../components/roles/List';
  import RoleDialog from '../../components/roles/Dialog';
  import ViewDialog from '../../components/roles/View';
  import Sidebar from '../../components/users/Sidebar';

  export default {
    components: {
      List,
      RoleDialog,
      ViewDialog,
      Sidebar
    },
  };
</script>
